// useDragAndDrop.js
import { useRef } from 'react';

export const useDragAndDrop = (layers, setLayers, groups, setGroups) => {
  const dragOverGroup = useRef(null);
  

  const handleDragStart = (e, layer) => {
    if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
      // If the target is a text input, do not handle the drag event
      return;
    }
    e.dataTransfer.setData('text/plain', layer.id);
    console.log('Dragging:', layer.id);
  };
  

  //Finds the next group ID
  const getNextGroupIDs = () => {
    const nextGroupIDs = {};
  
    Object.keys(groups).forEach(role => {
      const groupKeys = Object.keys(groups[role]);
      const groupNumbers = groupKeys.map(key => parseInt(key.replace('', ''), 10));
      const maxGroupNumber = Math.max(...groupNumbers, -1); // -1 ensures that if no groups exist, the next ID will be 0
      nextGroupIDs[role] = `${maxGroupNumber + 1}`;
    });
  
    return nextGroupIDs;
  };

  const generateGroups = () => {
    const groupedLayers = layers.reduce((acc, layer) => {
      const { role, group } = layer;
      if (!acc[role]) {
        acc[role] = {};
      }
      const groupKey = parseInt(group, 10); 
      if (!acc[role][groupKey]) {
        acc[role][groupKey] = [];
      }
      acc[role][groupKey].push(layer);
      return acc;
    }, {});
  
    console.log(groupedLayers);
  
    setGroups(groupedLayers);
  }

  const handleDragEnter = (e, group) => {
    e.preventDefault();
    dragOverGroup.current = group;
    console.log('Dragging over group:', group);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, groupID, role) => {
    e.preventDefault();
    console.log("LOGGING DRAG AND DROP");
    console.log(groupID, role);
    const draggedLayerId = e.dataTransfer.getData('text');
    const updatedLayers = layers.map(layer => {
      if (layer.id === draggedLayerId) {
        layer.group = parseInt(groupID, 10); // Ensure group is an integer
        layer.role = role;
      }
      return layer;
    });
    setLayers(updatedLayers);
    generateGroups();

  };

  return {
    handleDragStart,
    handleDragEnter,
    handleDragOver,
    handleDrop,
    dragOverGroup,
  };
};